import { render, staticRenderFns } from "./AddAssetForm.vue?vue&type=template&id=396dc8e8&"
import script from "./AddAssetForm.vue?vue&type=script&lang=js&"
export * from "./AddAssetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports